module.exports = __webpack_public_path__ + "fonts/Uni Sans Heavy.4e8910ad.otf";